import { Component } from '@angular/core';
import { CheckboxColumnsComponent } from './checkbox-columns.component';
import { CommonModule } from '@angular/common';
import { DocMeta } from "@template-ui/decorators";
import { EzPanelComponent } from "@template-ui/components/ez-panel/panel/panel.component";
import { InputConfig, InputWidthType, PanelHeaderConfig } from "@template-ui/types";

@DocMeta({
  showcaseTitle: "Permissions",
  hide: true,
})
@Component({
    selector: 'app-checkbox-columns-sample',
    imports: [CommonModule, CheckboxColumnsComponent, EzPanelComponent],
    templateUrl: './checkbox-columns-sample.component.html',
    styleUrl: './checkbox-columns-sample.component.scss'
})
export class CheckboxColumnsSampleComponent {

  permissions = [
    { label: 'View Dashboard', isChecked: true },
    { label: 'Edit Profile', isChecked: false },
    { label: 'Manage Users', isChecked: true },
    { label: 'Access Reports', isChecked: false },
    { label: 'Delete Records', isChecked: false },
    { label: 'Export Data', isChecked: true },
    { label: 'Configure Settings', isChecked: false },
    { label: 'Approve Requests (this will wrap if the width is under 2x)', isChecked: true },
    { label: 'Archive Projects', isChecked: false },
    { label: 'Create Projects', isChecked: true },
    { label: 'Assign Roles', isChecked: false },
    { label: 'Reset Passwords', isChecked: true },
    { label: 'View Audit Logs', isChecked: false },
    { label: 'Schedule Tasks', isChecked: true },
    { label: 'Send Notifications', isChecked: false },
    { label: 'Upload Files', isChecked: true },
    { label: 'Download Reports', isChecked: false },
    { label: 'Enable Features', isChecked: true }
  ];

  addActFormConfig: InputConfig[] = [
    {
      type: 'number',
      name: 'numCols',
      label: 'Columns'
    },
    {
      type: 'select',
      name: 'width',
      label: "Column width",
      options: [
        { value: 'fill', viewValue: 'Fill' },
        { value: '1x', viewValue: '1x' },
        { value: '2x', viewValue: '2x' },
        { value: '3x', viewValue: '3x' },
        { value: '4x', viewValue: '4x' },
        { value: '5x', viewValue: '5x' }
      ]
    },
    {
      type:'select',
      name:'orderBy',
      options: [
        { value: 'alphabetical', viewValue: 'Alphabetical'},
        { value: 'arrayOrder', viewValue: 'Array order'},
      ]
    },
    {
      type: 'checkbox',
      name: 'readOnly',
      label: 'Read only'
    }
  ];

  panelHeaderConfig: PanelHeaderConfig = {
    additionalActions: this.addActFormConfig
  }

  addActFormValues = {
    width: 'fill' as InputWidthType,
    numCols: 3,
    readOnly: false,
    orderBy: 'arrayOrder' as "arrayOrder" | "alphabetical"
  };

}